import { VueEditor } from 'vue2-editor'
export default VueEditor



// WEBPACK FOOTER //
// ./src/components/RichText/index.js